import { render, staticRenderFns } from "./server-category.vue?vue&type=template&id=57d5f844&scoped=true&"
import script from "./server-category.vue?vue&type=script&lang=js&"
export * from "./server-category.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d5f844",
  null
  
)

export default component.exports